
import { UserAPI } from "@/services/api/User.service";
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  nextTick,
} from "vue";
import { FormatMethods, getMaxLengthErrorMessage } from "@/helpers/data-format";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { TranslationService } from "@/core/services/TranslationService";
import { useToast } from "vue-toastification";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import VZFilter from "@/components/kt-datatable/components/VZFilter.vue";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
import VZModal from "@/components/content/VZModal.vue";
import { PAGE_ITEMS, usePagination } from "@/helpers/pagination";
import { hasPermission } from "@/core/services/permission.service";
import UserRoleModal from "@/views/user/modal/UserRoleModal.vue";
import UserRoleActivityModal from "@/views/user/modal/ActivityModal.vue";
import { IRoleCount } from "@/interfaces/iRole";
import { Modal } from "bootstrap";
import RoleCloneModal from "@/components/modals/forms/RoleCloneModal.vue";
interface IPagination {
  page: number;
  total: number;
  rowsPerPage: number;
  search?: string;
}
export default defineComponent({
  name: "user-roles-and-permission",
  components: {
    Form,
    Field,
    ErrorMessage,
    VZFilter,
    VZModal,
    UserRoleModal,
    UserRoleActivityModal,
    "vz-role-clone-modal": RoleCloneModal,
  },
  setup() {
    function t(key: string) {
      return TranslationService.translate(key);
    }
    const toast = useToast();

    const formRef = ref<null | HTMLFormElement>(null);
    const VZFilter = ref<null | HTMLFormElement>(null);
    const rolesAddmessage = t("pages.user.roleAddedMessage");
    const rolesEditmessage = t("pages.user.roleEditmessage");
    const rolesDeletemessage = t("common.multipleDeleteSuccessMessage");
    const rolesSelectmessage = t("pages.user.selectRoleMessage");
    let loading = ref(false);
    const roleWebId = ref<any>();
    const showDialog = ref<any>(false);
    const selectedRoleData = ref<IRoleCount>();
    const openUserNameModal = ref(false);
    const openCloneModal = ref(false);
    let roleObj = ref<any>({});
    let roles = ref<any>([]);
    let rolePermissions = ref<any>([]);
    let permissionGroups = ref<any>([]);
    let permissionGroupsFilter = ref<any>([]);
    let permissionGroupsCollpased = ref<any>([]);
    let arrayModuleNameList = ref<any>([]);
    let selectedRole = ref<any>({});
    const selectedRoleName = computed(() => {
      const item = roles.value.find(
        (item) => item.value == formData.value.selectedRoles[0]
      );
      return item ? item.label : null;
    });
    const format = computed(() => {
      return FormatMethods;
    });
    const { page, total, rowsPerPage } = usePagination();
    const pagination = ref<IPagination>({
      page: page.value,
      total: total.value,
      rowsPerPage: rowsPerPage.value,
    });
    const PAGE_ITEM = ref<number[]>(PAGE_ITEMS);
    const activeFilter = ref<number>(0);
    const localPreference = ref({});
    const formData = ref({
      RoleName: "",
      allselected: "true",
      searchRole: "",
      searchPermission: "",
      selectedRoles: ref<Array<any>>([]),
    });
    const tableFilter = ref<Array<IDataTableFilterOption>>([
      {
        key: "roleIds",
        label: TranslationService.translate("common.roles"),
        type: "lookup",
        attrs: {
          mode: "tags",
        }, //
        url: "security/filter/ROLES",
        textKey: "text",
        valueKey: "value",
      },
    ]);
    const localFilters = ref();
    onMounted(async () => {
      setCurrentPageBreadcrumbs(t("pages.user.roles"), ["Home", "Roles"]);
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

      try {
        // Initialize permission groups
        await UserAPI.getInstance()
          .getPermissionGroups()
          .then((res) => {
            permissionGroups.value = [...res];
            permissionGroupsFilter.value = [...res];

            // Initialize collapse states with first section open
            permissionGroupsCollpased.value = [];
            permissionGroupsCollpased.value.push(true); // First section open

            for (let i = 1; i < permissionGroupsFilter.value.length; i++) {
              permissionGroupsCollpased.value.push(false);
            }
          });

        // Load roles
        // await getUserRoles({
        //   ...localPreference.value,
        //   page: 0,
        //   size: rowsPerPage.value,
        //   sort: "created_date,desc",
        // });

        // // Initialize first role if exists
        // if (roles.value && roles.value.length > 0) {
        //   selectedRole.value = roles.value[0];
        //   await checkedToggleButton(selectedRole.value.value);
        //   await getRolePermissions();
        // }
      } catch (err) {
        console.error("Error in onMounted:", err);
      } finally {
        setTimeout(() => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        }, 2000);
      }
    });

    const selectAll = async function () {
      if (formData.value.selectedRoles.length === unlockedRoles.value.length) {
        formData.value.selectedRoles = [];
      } else {
        formData.value.selectedRoles = [];
        for (let i = 0; i < roles.value.length; i++) {
          if (!roles.value[i].lock || roles.value[i].lock === undefined) {
            formData.value.selectedRoles.push(roles.value[i].value);
          }
        }
      }
    };
    const toggleCollapse = (index) => {
      // Toggle the boolean value at the specified index
      permissionGroupsCollpased.value[index] =
        !permissionGroupsCollpased.value[index];
    };

    const getRolePermissions = async () => {
      rolePermissions.value = [];
      await UserAPI.getInstance()
        .getRolePermissions()
        .then((res) => {
          rolePermissions.value = [...res];
          roles?.value?.forEach((role: { permissions: any; value: any }) => {
            role.permissions = [];
            role.permissions = rolePermissions.value.filter(
              (rolePer: { roleId: any }) => rolePer.roleId == role.value
            );
          });
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const roleValidation = Yup.object().shape({
      Role: Yup.string()
        .strict(true)
        .max(30, getMaxLengthErrorMessage(t("common.name"), 30))
        .matches(/\S/, "Name is required")
        .test("roles", "Name is required", function (value) {
          return this.parent.Roles || !!value;
        }),
      Roles: Yup.string()
        .strict(true)
        .matches(/\S/, "Role is required")
        .test("role", "Role is required", function (value) {
          return this.parent.Role || !!value;
        }),
    });

    const getUserRoles = async (params?: Record<string, number | string>) => {
      await UserAPI.getInstance()
        .getRolesWithUserCount({
          page: page.value - 1,
          size: rowsPerPage.value,
          ...params,
          sort: "created_date,desc",
        })
        .then((data: any) => {
          roles.value = [];
          total.value = data.totalElements;
          rowsPerPage.value = data.size;
          page.value = data.page;
          data.content.map((obj) => {
            roles.value.push({
              label: obj.roleName,
              value: obj.webId,
              userCount: obj.count,
              lock: obj.lock,
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const checkPermission = (webId: any) => {
      return (
        roles?.value
          ?.filter(
            (role: { value: any }) => role.value == selectedRole.value.value
          )[0]
          ?.permissions?.filter(
            (perms: { permissionId: any }) => perms.permissionId == webId
          ).length > 0
      );
    };
    const updateSelectedRole = async (roleVal, element) => {
      if (selectedRole.value !== roleVal) {
        try {
          store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
          loading.value = true;

          // Update selected role
          selectedRole.value = roleVal;

          // Reset toggle states immediately to prevent showing old data
          arrayModuleNameList.value = [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ];

          // Wait for the toggle button check and permissions to load
          await checkedToggleButton(selectedRole.value.value);
          await getRolePermissions();

          // Force reactivity update
          await nextTick(() => {
            permissionGroups.value = [...permissionGroups.value];
            permissionGroupsFilter.value = [...permissionGroupsFilter.value];
          });
        } catch (err) {
          console.error("Error updating selected role:", err);
        } finally {
          loading.value = false;
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        }
      }
    };

    const getSpecificPermissionFromList = (list, id) => {
      return list.filter((perm) => perm.permissionCode.includes(id))[0]?.webId;
    };

    const getRolePermissionWebId = (permissionId) => {
      return roles?.value
        ?.filter(
          (role: { value: any }) => role.value == selectedRole.value.value
        )[0]
        ?.permissions?.filter(
          (perms: { permissionId: any }) => perms.permissionId == permissionId
        )[0].webId;
    };

    const closeForm = () => {
      formRef.value?.resetForm();
      let collapseDiv = document.getElementById("createGroup") as HTMLElement;
      collapseDiv.className = "border border-gray-300 collapse";
    };
    const submitClone = () => {
      getUserRoles({
        ...localPreference.value,
        page: 0,
        size: rowsPerPage.value,
        sort: "created_date,desc",
      })
        .then(() => {
          selectedRole.value = roles.value[0];
          getRolePermissions();
        })
        .catch((err) => {
          console.error(err);
        });
      formRef.value?.resetForm();
      let collapseDiv = document.getElementById("createGroup") as HTMLElement;
      collapseDiv.className = "border border-gray-300 collapse";
    };
    const createRole = async (reqData, { resetForm }) => {
      let collapseDiv = document.getElementById("createGroup") as HTMLElement;
      collapseDiv.className = "border border-gray-300 collapse";
      loading.value = true;

      if (formData.value.selectedRoles.length == 1) {
        // Update existing role logic...
        await UserAPI.getInstance()
          .updateRole(
            {
              roleName: reqData.Roles,
            },
            formData.value.selectedRoles[0]
          )
          .then(async () => {
            toast.success(rolesEditmessage);
            store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
            resetForm();

            await getUserRoles({
              ...localPreference.value,
              page: 0,
              size: rowsPerPage.value,
              sort: "created_date,desc",
            });

            VZFilter.value?.getLookupData();
            selectedRole.value = roles.value[0];

            // Reset collapse states and reopen first section
            await resetCollapseStates();

            await checkedToggleButton(selectedRole.value.value);
            await getRolePermissions();

            formData.value.selectedRoles.pop();
            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          })
          .catch(() => {
            //
          })
          .finally(() => {
            loading.value = false;
          });
      } else {
        // Create new role logic...
        reqData = {
          ...reqData,
          roleName: formData.value.RoleName,
          status: "ACTIVE",
        };

        await UserAPI.getInstance()
          .createRole(reqData)
          .then(async (createdRole) => {
            resetForm();

            await getUserRoles({
              ...localPreference.value,
              page: 0,
              size: rowsPerPage.value,
              sort: "created_date,desc",
            });

            VZFilter.value?.getLookupData();

            // Find the newly created role
            let newRole = null;
            if (createdRole && createdRole.webId) {
              newRole = roles.value.find((r) => r.value === createdRole.webId);
            } else if (createdRole && createdRole.roleName) {
              newRole = roles.value.find(
                (r) => r.label === createdRole.roleName
              );
            } else {
              newRole = roles.value.find(
                (r) => r.label === formData.value.RoleName
              );
            }

            if (newRole) {
              selectedRole.value = newRole;
            } else {
              selectedRole.value = roles.value[0];
            }

            // Reset collapse states and reopen first section
            await resetCollapseStates();

            await checkedToggleButton(selectedRole.value.value);
            await getRolePermissions();

            toast.success(rolesAddmessage);
          })
          .catch(() => {
            //
          })
          .finally(() => {
            loading.value = false;
          });
      }
    };
    const resetCollapseStates = async () => {
      // Reset all collapse states
      permissionGroupsCollpased.value = [];

      // Rebuild collapse states with first one open
      if (
        permissionGroupsFilter.value &&
        permissionGroupsFilter.value.length > 0
      ) {
        permissionGroupsCollpased.value.push(true); // First section open

        // Rest closed
        for (let i = 1; i < permissionGroupsFilter.value.length; i++) {
          permissionGroupsCollpased.value.push(false);
        }
      }

      await nextTick();
    };
    const setItemsPerPage = () => {
      getUserRoles({
        ...localPreference.value,
        page: 0,
        size: rowsPerPage.value,
        sort: "created_date,desc",
      })
        .then(async () => {
          store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
          selectedRole.value = roles.value[0];
          await getRolePermissions();
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const currentPageChange = (val) => {
      getUserRoles({
        ...localPreference.value,
        page: val - 1,
        sort: "created_date,desc",
      })
        .then(async () => {
          store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
          selectedRole.value = roles.value[0];
          await getRolePermissions();
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const searchRole = async function () {
      try {
        store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
        loading.value = true;

        if (formData.value.searchRole !== "") {
          // Filter roles based on search term
          roles.value = roles.value.filter((role) =>
            role.label
              .toLowerCase()
              .includes(formData.value.searchRole.toLowerCase())
          );
        } else {
          // Fetch all roles when search is cleared
          await getUserRoles({
            ...localPreference.value,
            page: 0,
            size: rowsPerPage.value,
            ...localFilters.value,
          });
        }

        // Update selectedRole to the first role in the filtered list or reset if empty
        if (roles.value.length > 0) {
          selectedRole.value = roles.value[0];
        } else {
          selectedRole.value = {};
          rolePermissions.value = [];
          arrayModuleNameList.value = [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ];
        }

        // Refresh permissions and toggle states for the selected role
        if (selectedRole.value.value) {
          await checkedToggleButton(selectedRole.value.value);
          await getRolePermissions();
        }

        // Reset collapse states
        await resetCollapseStates();
      } catch (err) {
        console.error("Error in searchRole:", err);
        toast.error(t("common.errorMessage"));
      } finally {
        loading.value = false;
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }
    };
    watch(
      () => formData.value.searchRole,
      (newValue, oldValue) => {
        if (newValue.length > 2 || newValue.length == 0) {
          searchRole();
        }
      }
    );
    const refreshList = async () => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      getUserRoles({
        ...localPreference.value,
        page: 0,
        size: rowsPerPage.value,
        sort: "created_date,desc",
      })
        .then(() => {
          selectedRole.value = roles.value[0];
          getRolePermissions();
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const searchPermission = async function () {
      if (
        formData.value.searchPermission != "" &&
        formData.value.searchPermission.length > 2
      ) {
        permissionGroupsFilter.value = [];
        let normalizedSearchTerm =
          formData.value.searchPermission.toLowerCase();

        if (
          normalizedSearchTerm.includes("br") ||
          normalizedSearchTerm.includes("bra") ||
          normalizedSearchTerm.includes("branch")
        ) {
          normalizedSearchTerm = "branches";
        } else if (
          normalizedSearchTerm.includes("ch") ||
          normalizedSearchTerm.includes("cha") ||
          normalizedSearchTerm.includes("chat")
        ) {
          normalizedSearchTerm = "chat";
        }
        const permGroup = JSON.parse(JSON.stringify(permissionGroups.value));
        permGroup.map((group) => {
          permissionGroupsFilter.value.push(
            group.childPermissions.filter((childPerm) =>
              childPerm.title.toLowerCase().includes(normalizedSearchTerm)
            ).length > 0
              ? group
              : ""
          );
        });
        permissionGroupsFilter.value = permissionGroupsFilter.value.filter(
          (perm) => perm != ""
        );
        permissionGroupsFilter.value.map((newGroup) => {
          let childPerms = [];
          childPerms = newGroup.childPermissions.filter((childPerm) =>
            childPerm.title.toLowerCase().includes(normalizedSearchTerm)
          );
          newGroup.childPermissions = [];
          newGroup.childPermissions = childPerms;
        });
      } else {
        permissionGroupsFilter.value = [];
        permissionGroupsFilter.value = JSON.parse(
          JSON.stringify(permissionGroups.value)
        );
      }
    };
    const deleteSelectedRoles = async function () {
      if (formData.value.selectedRoles.length > 0) {
        const filteredIds = formData.value.selectedRoles.filter((id) => {
          const foundItem = roles.value.find((item) => item.value === id);
          return !(foundItem && foundItem.lock);
        });

        if (filteredIds.length > 0) {
          showDialog.value = false;
          loading.value = true;
          store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

          try {
            await UserAPI.getInstance().bulkDeleteRole("roles", filteredIds);
            toast.success(`Selected role(s) ${rolesDeletemessage}`);

            // Clear form data
            formData.value.searchRole = "";
            formData.value.RoleName = "";
            formData.value.selectedRoles = [];
            formData.value.allselected = "true";

            // Refresh role list
            await getUserRoles({
              ...localPreference.value,
              page: 0,
              size: rowsPerPage.value,
              sort: "created_date,desc",
            });

            // Update selected role
            if (roles.value.length > 0) {
              selectedRole.value = roles.value[0];
              await checkedToggleButton(selectedRole.value.value);
              await getRolePermissions();
            } else {
              selectedRole.value = {};
              rolePermissions.value = [];
              permissionGroupsFilter.value = JSON.parse(
                JSON.stringify(permissionGroups.value)
              );
              arrayModuleNameList.value = [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
              ];
            }

            // Reset collapse states
            await resetCollapseStates();

            // Refresh filter data
            if (VZFilter.value) {
              VZFilter.value.getLookupData();
            }
          } catch (err) {
            console.error("Error deleting roles:", err);
            toast.error(t("common.errorMessage"));
          } finally {
            loading.value = false;
            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          }
        } else {
          toast.error(t("pages.user.lockedRolesError"));
          formData.value.selectedRoles = [];
        }
      } else {
        toast.error(t("pages.user.selectRoleMessage"));
      }

      store.dispatch(Actions.UPDATE_USER);
    };
    const updatePermissionForRole = async (
      permissionId,
      checked?,
      event?,
      title?
    ) => {
      try {
        loading.value = true;
        if (checkPermission(permissionId)) {
          await UserAPI.getInstance().deleteRolePermission(
            getRolePermissionWebId(permissionId)
          );
          const index = rolePermissions.value.findIndex(
            (prem) => prem.webId == getRolePermissionWebId(permissionId)
          );
          if (index > -1) {
            rolePermissions.value.splice(index, 1);
          }
          const roleIndex = roles.value.findIndex(
            (role) => role.value == selectedRole.value.value
          );
          const rolePermissionIndex =
            roles?.value[roleIndex].permissions?.findIndex(
              (perms: { permissionId: any }) =>
                perms.permissionId == permissionId
            ) ?? -1;
          if (rolePermissionIndex > -1) {
            roles.value[roleIndex].permissions.splice(rolePermissionIndex, 1);
          }
          toast.success(
            `Permission has been removed from ${selectedRole.value.label}`
          );
        } else {
          const newData = await UserAPI.getInstance().saveRolePermissions({
            permissionId: permissionId,
            roleId: selectedRole.value.value,
          });
          rolePermissions.value.push(newData);
          const roleIndex = roles.value.findIndex(
            (role) => role.value == selectedRole.value.value
          );
          if (roleIndex > -1) {
            roles.value[roleIndex].permissions.push(newData);
          }

          toast.success(
            `Permission has been assigned to ${selectedRole.value.label}`
          );
        }
        const param = {
          permissionCode: title,
          roleId: selectedRole.value.value,
          toggle: event,
        };
        await UserAPI.getInstance().updateSpecificRoleModuel(param);
        await checkedToggleButton(selectedRole.value.value);
        store.dispatch(Actions.UPDATE_USER);
      } catch (error) {
        //call
        getUserRoles({
          ...localPreference.value,
          page: 0,
          size: rowsPerPage.value,
          sort: "created_date,desc",
        });
        getRolePermissions();
      } finally {
        loading.value = false;
      }
    };
    const onFilterChange = (filters) => {
      activeFilter.value =
        Object.keys(filters).filter((item) => {
          if (
            (Array.isArray(filters[item]) && !filters[item]?.length) ||
            !filters[item] ||
            filters[item] === null
          ) {
            return false;
          }
          return true;
        }).length ?? 0;
      localFilters.value = Object.keys(filters)
        .filter((key) => {
          const lookup =
            (tableFilter.value &&
              tableFilter.value.findIndex(
                (tab) => tab.key === key && tab.type === "lookup"
              )) ??
            -1;
          if (lookup > -1) {
            return !filters[key].includes("-1");
          }
          return true;
        })
        .reduce((filter, key) => {
          filter[key] = filters[key];
          return filter;
        }, {});
      if (!filters.roleIds) {
        getUserRoles()
          .then(async () => {
            selectedRole.value = roles.value[0];
            await checkedToggleButton(selectedRole.value.value);
            await getRolePermissions();
          })
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      getUserRoles({
        ...localPreference.value,
        page: 0,
        size: rowsPerPage.value,
        ...localFilters.value,
      }).then(async () => {
        // After filtering, select the first role and update side permissions
        selectedRole.value = roles.value[0];
        await checkedToggleButton(selectedRole.value.value);
        await getRolePermissions();
      });
    };
    const resetWebId = (id) => {
      if (roleWebId.value === undefined || roleWebId.value === id) {
        roleWebId.value = id;
      } else if (roleWebId.value !== undefined) {
        let existingElement = document.querySelector(
          ".role-clone.show-clone-" + roleWebId.value
        );
        if (existingElement) {
          existingElement.classList.remove("show");
        }
        roleWebId.value = id;
      }
    };
    const setRoleCloneData = async (data: any) => {
      let existingElement = document.querySelector(
        ".role-clone.show-clone-" + data.value
      );
      if (existingElement) {
        existingElement.classList.remove("show");
      }
      openCloneModal.value = true;
      roleObj.value = data;
      await nextTick();
      const modal = new Modal(
        document.getElementById(`kt_role_clone`) as HTMLElement
      );
      modal.show();
    };
    const unlockedRoles = computed(() => {
      return roles.value.filter(
        (role) => !role.lock || role.lock === undefined
      );
    });
    function openUserModal(role) {
      selectedRoleData.value = { ...role };
      openUserNameModal.value = true;
    }
    const disableModule = async (name, checked?) => {
      const param = {
        permissionCode: name,
        roleId: selectedRole.value.value,
        toggle: checked,
      };

      try {
        loading.value = true;
        store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

        await UserAPI.getInstance().updateRoleModuel(param);

        if (checked) {
          toast.success(
            `${name} permissions have been assigned to ${selectedRole.value.label}`
          );
        } else {
          toast.success(
            `${name} permissions have been removed from ${selectedRole.value.label}`
          );
        }

        // Refresh the toggle states for current role
        await checkedToggleButton(selectedRole.value.value);

        await store.dispatch(Actions.UPDATE_USER);
      } catch (error) {
        console.error("Error in disableModule:", error);
      } finally {
        await getUserRoles({
          ...localPreference.value,
          page: 0,
          size: rowsPerPage.value,
          sort: "created_date,desc",
        });
        await getRolePermissions();
        loading.value = false;
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }
    };
    const checkedToggleButton = async (id: any) => {
      try {
        loading.value = true;

        // Create completely new array to ensure reactivity
        const newToggleStates = [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ];

        const data = await UserAPI.getInstance().checkedModuleToggleButton(id);

        // Map the response to correct array positions
        data.forEach((item) => {
          switch (item.permissionCode) {
            case "Applications":
              newToggleStates[0] = Boolean(item.toggle);
              break;
            case "Business":
              newToggleStates[1] = Boolean(item.toggle);
              break;
            case "Dashboard":
              newToggleStates[2] = Boolean(item.toggle);
              break;
            case "Integrations":
              newToggleStates[3] = Boolean(item.toggle);
              break;
            case "Settings":
              newToggleStates[4] = Boolean(item.toggle);
              break;
            case "Templates":
              newToggleStates[5] = Boolean(item.toggle);
              break;
            case "Users":
              newToggleStates[6] = Boolean(item.toggle);
              break;
          }
        });

        // Replace the entire array to trigger reactivity
        arrayModuleNameList.value = newToggleStates;

        // Force Vue to update the DOM
        await nextTick();
      } catch (error) {
        console.error("Error in checkedToggleButton:", error);
        // Reset to default state on error
        arrayModuleNameList.value = [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ];
      } finally {
        loading.value = false;
      }
    };

    const isRoleLocked = (selectedRoles) => {
      if (selectedRoles.length === 1) {
        const foundRole = roles.value.find(
          (role) => String(role.value) === String(selectedRoles[0])
        );
        return foundRole ? !foundRole.lock : true;
      }
      return false;
    };

    // onMounted(() => {
    //   getUserRoles({
    //     ...localPreference.value,
    //     page: 0,
    //     size: rowsPerPage.value,
    //     sort: "created_date,desc",
    //   }).then(() => {
    //     selectedRole.value = roles.value[0];
    //     checkedToggleButton(selectedRole.value.value);
    //     getRolePermissions();
    //   });
    // });
    return {
      arrayModuleNameList,
      checkedToggleButton,
      disableModule,
      format,
      loading,
      roles,
      permissionGroups,
      permissionGroupsFilter,
      permissionGroupsCollpased,
      getSpecificPermissionFromList,
      checkPermission,
      updateSelectedRole,
      selectedRole,
      selectedRoleName,
      updatePermissionForRole,
      createRole,
      formRef,
      roleValidation,
      formData,
      searchRole,
      deleteSelectedRoles,
      selectAll,
      searchPermission,
      t,
      onFilterChange,
      pagination,
      tableFilter,
      activeFilter,
      closeForm,
      submitClone,
      hasPermission,
      showDialog,
      openUserModal,
      openUserNameModal,
      selectedRoleData,
      toggleCollapse,
      resetWebId,
      setRoleCloneData,
      openCloneModal,
      roleObj,
      rowsPerPage,
      PAGE_ITEM,
      page,
      total,
      setItemsPerPage,
      currentPageChange,
      refreshList,
      isRoleLocked,
      unlockedRoles,
      VZFilter,
    };
  },
});
